"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;

var React = _interopRequireWildcard(require("react"));

var _stylitas = require("@creditas/stylitas");

var _Icons = require("./Icons");

var _core = require("@emotion/core");

var rotate = (0, _stylitas.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));

var style = function style() {
  return (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-itens: center;\n  justify-content: center;\n  animation: ", " 1s linear infinite;\n"])), rotate);
};

var LoadingStyled = _stylitas.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), style);

var Loading = function Loading() {
  return (0, _core.jsx)(LoadingStyled, {
    "data-testid": "loading"
  }, (0, _core.jsx)(_Icons.Loading, null));
};

exports.Loading = Loading;
Loading.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Loading"
};